(function () {
    'use strict';

    if (window.ArcherProductFitmentBooted) return;
    window.ArcherProductFitmentBooted = true;

    const API_BASE = '/apps/tecdoc';
    const STORAGE_KEY = 'vehicle_fitment_vehicle';
    const DETAILS_CACHE = new Map();

    const $ = (root, selector) => root ? root.querySelector(selector) : null;
    const $$ = (root, selector) => root ? Array.from(root.querySelectorAll(selector)) : [];

    function esc(value) {
        return String(value || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    function savedVehicle(storeId, tecDocProfile) {
        try {
            const vehicle = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
            if (!vehicle) return null;
            if (vehicle.storeId !== storeId) return null;
            const savedProfile = vehicle.tecDocProfile || vehicle.profile;
            if (savedProfile !== tecDocProfile) return null;
            return vehicle;
        } catch (_) {
            return null;
        }
    }

    function vehicleId(vehicle) {
        return vehicle && (vehicle.vehicleId || vehicle.VehicleId || vehicle.id || vehicle.Id);
    }

    function translateVehicleText(value) {
        return window.ArcherVehicleLabels && window.ArcherVehicleLabels.translateText
            ? window.ArcherVehicleLabels.translateText(value)
            : String(value || '');
    }

    function vehicleLabel(vehicle) {
        return [
            vehicle && (vehicle.makeName || vehicle.MakeName),
            translateVehicleText(vehicle && (vehicle.modelName || vehicle.ModelName)),
            translateVehicleText(vehicle && (vehicle.typeName || vehicle.TypeName))
        ].filter(Boolean).join(' ');
    }

    function vehicleMeta(vehicle) {
        return [
            vehicle && (vehicle.engineCode || vehicle.EngineCode),
            vehicle && (vehicle.powerHp || vehicle.PowerHp) ? `${vehicle.powerHp || vehicle.PowerHp} hp` : '',
            vehicle && (vehicle.yearFrom || vehicle.YearFrom)
        ].filter(Boolean).join(' | ');
    }

    function vehicleSpecRows(root, vehicle) {
        return [
            [root.dataset.engineLabel || 'Engine', vehicle && (vehicle.engineCode || vehicle.EngineCode)],
            [root.dataset.powerLabel || 'Power', vehicle && [
                vehicle.powerKw || vehicle.PowerKw,
                vehicle.powerHp || vehicle.PowerHp
            ].filter(Boolean).join(' / ')],
            [root.dataset.yearLabel || 'Year', vehicle && [
                vehicle.yearFrom || vehicle.YearFrom,
                vehicle.yearTo || vehicle.YearTo
            ].filter(Boolean).join(' - ')],
            [root.dataset.bodyLabel || 'Body', translateVehicleText(vehicle && (vehicle.bodyStyle || vehicle.BodyStyle))]
        ].filter((row) => row[1]);
    }

    function displaySku(sku) {
        return String(sku || '')
            .trim()
            .replace(/-\d+(?:-\d+)?(?:_\d+)?$/i, '')
            .replace(/_\d+$/i, '');
    }

    function buildResultsUrl(vehicle, storeId, tecDocProfile) {
        const id = vehicleId(vehicle);
        if (!id) return '/pages/vehicle-results';

        const params = new URLSearchParams({
            vehicleId: String(id),
            storeId,
            tecDocProfile,
            family: vehicle.family || 'injectors'
        });
        return `/pages/vehicle-results?${params.toString()}`;
    }

    function buildFinderUrl(root) {
        const target = root.dataset.finderUrl || '/';
        const url = new URL(target, window.location.origin);
        url.searchParams.set('changeVehicle', '1');
        return `${url.pathname}${url.search}${url.hash}`;
    }

    function renderVehicleCard(root, vehicle, options) {
        const card = $(root, '[data-fitment-vehicle-card]');
        if (!card) return;

        if (!vehicle || !vehicleId(vehicle)) {
            card.hidden = true;
            card.innerHTML = '';
            return;
        }

        const label = vehicleLabel(vehicle);
        const meta = vehicleMeta(vehicle);
        const make = vehicle && (vehicle.makeName || vehicle.MakeName || '');
        const image = vehicle && (vehicle.imageUrl || vehicle.ImageUrl || '');
        const isExample = options && options.example;
        card.hidden = false;
        card.innerHTML = `
      <div class="vehicle-product-fitment__vehicle-media">
        ${image ? `<img src="${esc(image)}" alt="${esc(label)}" loading="lazy">` : `<span>${esc(String(make || label).slice(0, 1))}</span>`}
      </div>
      <div>
        <span>${esc(isExample ? root.dataset.exampleLabel || 'Example compatible vehicle' : root.dataset.vehicleLabel || 'Selected vehicle')}</span>
        <strong>${esc(label)}</strong>
        ${meta ? `<small>${esc(meta)}</small>` : ''}
      </div>
      ${isExample ? `<p class="vehicle-product-fitment__vehicle-example">${esc(root.dataset.exampleText || "No vehicle is selected yet, so this example is filled automatically from this product's fitment data.")}</p>` : ''}`;
    }

    function renderFacts(root, sku, vehicle) {
        const facts = $(root, '[data-fitment-facts]');
        if (!facts) return;

        const cleanSku = displaySku(sku);
        const rows = [
            [root.dataset.partLabel || 'Part number', cleanSku || sku],
            [root.dataset.vehicleLabel || 'Selected vehicle', vehicle && vehicleId(vehicle) ? vehicleLabel(vehicle) : 'Not selected']
        ].filter((row) => row[1]);

        facts.hidden = rows.length === 0;
        facts.innerHTML = rows.map((row) => `<div><dt>${esc(row[0])}</dt><dd>${esc(row[1])}</dd></div>`).join('');
    }

    function renderNote(root) {
        const note = $(root, '[data-fitment-note]');
        if (!note) return;

        const text = root.dataset.noteText || '';
        if (!text) {
            note.hidden = true;
            note.innerHTML = '';
            return;
        }

        note.hidden = false;
        note.innerHTML = `<strong>${esc(root.dataset.noteLabel || 'Before ordering')}</strong><span>${esc(text)}</span>`;
    }

    function firstDetailsVehicle(data) {
        const vehicles = data && Array.isArray(data.vehicles) ? data.vehicles : [];
        return vehicles.length ? vehicles[0] : null;
    }

    function setPill(root, status, label) {
        const pill = $(root, '[data-fitment-pill]');
        if (!pill) return;
        pill.dataset.status = status || 'idle';
        pill.textContent = label || '';
    }

    async function fetchFitmentDetails(root) {
        const sku = String(root.dataset.sku || '').trim();
        if (!sku) throw new Error(root.dataset.emptyText || 'No fitment data is currently available for this product.');

        const params = new URLSearchParams({
            sku,
            storeId: root.dataset.storeId || 'archer-diesel',
            tecDocProfile: root.dataset.tecDocProfile || 'uk',
            lang: document.documentElement.lang || 'en',
            limit: root.dataset.limit || '80'
        });

        const cacheKey = params.toString();
        if (!DETAILS_CACHE.has(cacheKey)) {
            DETAILS_CACHE.set(cacheKey, (async () => {
                const response = await fetch(`${API_BASE}/product-fitment-details?${cacheKey}`, { headers: { Accept: 'application/json' } });
                const json = await response.json().catch(() => null);
                if (!response.ok || !json || json.success === false) {
                    throw new Error((json && json.error) || `Request failed (${response.status})`);
                }
                return json.data || {};
            })());
        }

        try {
            return await DETAILS_CACHE.get(cacheKey);
        } catch (error) {
            DETAILS_CACHE.delete(cacheKey);
            throw error;
        }
    }

    function renderDetailsEmpty(root, message) {
        const body = $(root, '[data-fitment-details-body]');
        if (!body) return;
        body.innerHTML = `<div class="archer-fitment-details__empty">${esc(message || root.dataset.emptyText || 'No fitment data is currently available for this product.')}</div>`;
    }

    function renderVehicleItem(root, vehicle) {
        const label = vehicleLabel(vehicle);
        const meta = vehicleMeta(vehicle);
        const image = vehicle && (vehicle.imageUrl || vehicle.ImageUrl || '');
        const make = vehicle && (vehicle.makeName || vehicle.MakeName || '');
        const specs = vehicleSpecRows(root, vehicle);

        return `
      <article class="archer-fitment-details__vehicle">
        <div class="archer-fitment-details__vehicle-copy">
          <strong>${esc(label)}</strong>
          ${meta ? `<p>${esc(meta)}</p>` : ''}
        </div>
        <div class="archer-fitment-details__vehicle-media">
          ${image ? `<img src="${esc(image)}" alt="${esc(label)}" loading="lazy">` : `<span>${esc(String(make || label).slice(0, 1))}</span>`}
        </div>
        <div class="archer-fitment-details__vehicle-specs">
          ${specs.length ? `<dl>${specs.map((row) => `<div><dt>${esc(row[0])}</dt><dd>${esc(row[1])}</dd></div>`).join('')}</dl>` : ''}
        </div>
      </article>`;
    }

    function bindDetailsToggle(root, remainingVehicles) {
        const button = $(root, '[data-fitment-details-toggle]');
        const list = $(root, '[data-fitment-details-list]');
        if (!button || !list) return;

        button.addEventListener('click', () => {
            const expanded = button.getAttribute('aria-expanded') === 'true';
            if (expanded) {
                $$(list, '[data-extra-vehicle]').forEach((node) => node.remove());
                button.setAttribute('aria-expanded', 'false');
                button.textContent = `${root.dataset.showMoreLabel || 'Show more vehicles'} (${remainingVehicles.length})`;
                return;
            }

            list.insertAdjacentHTML('beforeend', remainingVehicles
                .map((vehicle) => `<div data-extra-vehicle>${renderVehicleItem(root, vehicle)}</div>`)
                .join(''));
            button.setAttribute('aria-expanded', 'true');
            button.textContent = root.dataset.showLessLabel || 'Show fewer vehicles';
        });
    }

    function renderFitmentDetails(root, data) {
        const body = $(root, '[data-fitment-details-body]');
        if (!body) return;

        const vehicles = data && Array.isArray(data.vehicles) ? data.vehicles : [];
        const oems = data && Array.isArray(data.oemNumbers) ? data.oemNumbers : [];
        const totalVehicles = Number((data && data.totalVehicles) || vehicles.length || 0);
        const initialVisible = Math.max(1, Number(root.dataset.initialVisible || 6) || 6);
        const visibleVehicles = vehicles.slice(0, initialVisible);
        const remainingVehicles = vehicles.slice(initialVisible);

        if (!vehicles.length && !oems.length) {
            renderDetailsEmpty(root, root.dataset.emptyText);
            return;
        }

        body.innerHTML = `
      <div class="archer-fitment-details__summary">
        <div>
          <span>${esc(root.dataset.vehiclesLabel || 'Compatible vehicles')}</span>
          <strong>${esc(totalVehicles)} vehicle${totalVehicles === 1 ? '' : 's'}</strong>
        </div>
        <div>
          <span>${esc(root.dataset.oemLabel || 'Reference numbers')}</span>
          <strong>${esc(oems.length)} reference${oems.length === 1 ? '' : 's'}</strong>
        </div>
      </div>
      ${oems.length ? `
        <div class="archer-fitment-details__refs" aria-label="${esc(root.dataset.oemLabel || 'Reference numbers')}">
          ${oems.slice(0, 18).map((oem) => `
            <span>
              <strong>${esc(oem.articleNumber || oem.ArticleNumber || '')}</strong>
              ${oem.brand || oem.Brand ? `<small>${esc(oem.brand || oem.Brand)}</small>` : ''}
            </span>
          `).join('')}
        </div>` : ''}
      ${vehicles.length ? `
        <div class="archer-fitment-details__vehicles" data-fitment-details-list>
          ${visibleVehicles.map((vehicle) => renderVehicleItem(root, vehicle)).join('')}
        </div>` : ''}
      ${remainingVehicles.length ? `
        <button type="button" class="archer-fitment-details__toggle" data-fitment-details-toggle aria-expanded="false">
          ${esc(root.dataset.showMoreLabel || 'Show more vehicles')} (${remainingVehicles.length})
        </button>` : ''}`;

        bindDetailsToggle(root, remainingVehicles);
    }

    async function loadDetails(root) {
        if (root.dataset.detailsReady === 'true') return;
        root.dataset.detailsReady = 'true';

        try {
            const data = await fetchFitmentDetails(root);
            renderFitmentDetails(root, data);
        } catch (error) {
            root.dataset.detailsReady = 'false';
            renderDetailsEmpty(root, error.message || root.dataset.emptyText);
        }
    }

    function renderActions(root, vehicle, storeId, tecDocProfile) {
        const actions = $(root, '[data-fitment-actions]');
        if (!actions) return;

        const selectLabel = root.dataset.selectLabel || 'Select vehicle';
        const backLabel = root.dataset.backLabel || 'Back to compatible results';

        actions.innerHTML = `
      <button type="button" class="vehicle-fitment__button vehicle-fitment__button--ghost" data-fitment-select>${esc(selectLabel)}</button>
      ${vehicle && vehicleId(vehicle) ? `<a class="vehicle-fitment__button" href="${esc(buildResultsUrl(vehicle, storeId, tecDocProfile))}">${esc(backLabel)}</a>` : ''}`;

        $(root, '[data-fitment-select]').addEventListener('click', () => {
            const finder = document.querySelector('[data-vehicle-finder]');
            if (finder) {
                localStorage.removeItem(STORAGE_KEY);
                document.dispatchEvent(new CustomEvent('vehiclefitment:cleared'));
                finder.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
                window.location.href = buildFinderUrl(root);
            }
        });
    }

    async function check(root) {
        const requestId = String((Number(root.dataset.fitmentRequestId || 0) || 0) + 1);
        root.dataset.fitmentRequestId = requestId;
        const isCurrentRequest = () => root.dataset.fitmentRequestId === requestId;
        const storeId = root.dataset.storeId || 'archer-diesel';
        const tecDocProfile = root.dataset.tecDocProfile || 'uk';
        const sku = root.dataset.sku || '';
        const cleanSku = displaySku(sku);
        const vehicle = savedVehicle(storeId, tecDocProfile);
        const title = $(root, '[data-fitment-title]');
        const text = $(root, '[data-fitment-text]');

        root.dataset.fitmentStatus = 'idle';
        renderVehicleCard(root, vehicle);
        renderFacts(root, sku, vehicle);
        renderNote(root);
        renderActions(root, vehicle, storeId, tecDocProfile);

        if (!sku) {
            setPill(root, 'unknown', 'Unavailable');
            title.textContent = 'Compatibility check unavailable';
            text.textContent = 'This product has no SKU to compare against vehicle fitment data.';
            return;
        }

        if (!vehicle || !vehicleId(vehicle)) {
            setPill(root, 'idle', 'Vehicle needed');
            title.textContent = root.dataset.noVehicleTitle || 'Check if this part fits your vehicle';
            text.textContent = root.dataset.noVehicleText || 'Select your vehicle to verify compatibility before ordering.';
            fetchFitmentDetails(root)
                .then((data) => {
                    if (!isCurrentRequest()) return;
                    const exampleVehicle = firstDetailsVehicle(data);
                    if (exampleVehicle && !savedVehicle(storeId, tecDocProfile)) {
                        renderVehicleCard(root, exampleVehicle, { example: true });
                    }
                })
                .catch(() => {});
            return;
        }

        setPill(root, 'checking', 'Checking');
        title.textContent = 'Checking compatibility...';
        text.textContent = `Checking ${cleanSku || sku} against ${vehicleLabel(vehicle)}.`;
        root.dataset.fitmentStatus = 'checking';

        const params = new URLSearchParams({
            storeId,
            tecDocProfile,
            vehicleId: String(vehicleId(vehicle)),
            sku
        });

        try {
            const response = await fetch(`${API_BASE}/product-compatibility?${params.toString()}`, { headers: { Accept: 'application/json' } });
            const json = await response.json();
            if (!response.ok || !json || json.success === false) throw new Error((json && json.error) || 'Compatibility check failed');
            if (!isCurrentRequest()) return;

            const result = json.data || {};
            if (result.isCompatible || result.IsCompatible) {
                root.dataset.fitmentStatus = 'compatible';
                setPill(root, 'compatible', 'Compatible');
                title.textContent = root.dataset.compatibleTitle || 'Fits your selected vehicle';
                text.textContent = `${cleanSku || sku} is listed for ${vehicleLabel(vehicle)} in our fitment data.`;
            } else {
                root.dataset.fitmentStatus = 'incompatible';
                setPill(root, 'incompatible', 'Check required');
                title.textContent = root.dataset.incompatibleTitle || 'Not listed for your selected vehicle';
                text.textContent = `${cleanSku || sku} is not currently listed for ${vehicleLabel(vehicle)} in our fitment data.`;
            }
        } catch (error) {
            if (!isCurrentRequest()) return;
            root.dataset.fitmentStatus = 'unknown';
            setPill(root, 'unknown', 'Manual check');
            title.textContent = root.dataset.unknownTitle || 'Compatibility could not be confirmed';
            text.textContent = error.message || 'Please compare part numbers manually before ordering.';
        }
    }

    function init(root) {
        check(root);
    }

    function boot() {
        $$(document, '[data-product-fitment]').forEach(init);
        $$(document, '[data-product-fitment-details]').forEach(loadDetails);
    }

    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('vehiclefitment:selected', boot);
    document.addEventListener('vehiclefitment:cleared', boot);
    document.addEventListener('shopify:section:load', boot);
})();
